import React, { useState, useEffect, useRef } from 'react';
import {FaTwitter ,FaInstagram ,FaFacebookF, FaWhatsapp, FaYoutube, FaTiktok} from "react-icons/fa";
import { GoRocket } from "react-icons/go";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MdContactPhone } from 'react-icons/md';
import { BsWhatsapp } from "react-icons/bs";

const FooterTwo = ({langUS=false, fbclid_short_code=null, showWasi=true}) => {

    // console.log("FooterTwo render", showWasi);
    // Estados para el mensaje flotante
    const [messageShown, setMessageShown] = useState(false);
    const [messageClosed, setMessageClosed] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    
    // Estados para la notificación badge
    const [showNotificationBadge, setShowNotificationBadge] = useState(false);
    const [notificationCount, setNotificationCount] = useState(1);
    
    // Referencias para los timers
    const messageTimeoutRef = useRef(null);
    const inactivityTimeoutRef = useRef(null);
    const autoHideTimeoutRef = useRef(null);
    const badgeTimeoutRef = useRef(null);

    // Función para mostrar el mensaje flotante
    const showFloatingMessage = () => {
        if (!messageClosed && !messageShown) {
            setShowMessage(true);
            setMessageShown(true);
            
            // Mostrar badge de notificación junto con el mensaje
            setShowNotificationBadge(true);
            
            // Auto-ocultar después de 8 segundos
            autoHideTimeoutRef.current = setTimeout(() => {
                if (!messageClosed) {
                    hideFloatingMessage();
                }
            }, 8000);
        }
    };

    // Función para ocultar el mensaje flotante
    const hideFloatingMessage = () => {
        setShowMessage(false);
        setMessageShown(false);
    };

    // Función para cerrar definitivamente el mensaje
    const closeFloatingMessage = () => {
        hideFloatingMessage();
        setMessageClosed(true);
        if (autoHideTimeoutRef.current) {
            clearTimeout(autoHideTimeoutRef.current);
        }
    };

    // Función para mostrar solo el badge sin mensaje
    const showNotificationOnly = () => {
        if (!showNotificationBadge && !messageClosed) {
            setShowNotificationBadge(true);
            setNotificationCount(1);
        }
    };

    // Función para resetear el mensaje cuando se hace hover sobre el botón
    const resetMessageTimer = () => {
        if (!messageClosed) {
            if (messageTimeoutRef.current) {
                clearTimeout(messageTimeoutRef.current);
            }
            hideFloatingMessage();
            
            // Reiniciar el timer
            messageTimeoutRef.current = setTimeout(() => {
                showFloatingMessage();
            }, 10000); // 10 segundos
        }
    };

    // Función para resetear el timer de inactividad
    const resetInactivityTimer = () => {
        if (inactivityTimeoutRef.current) {
            clearTimeout(inactivityTimeoutRef.current);
        }
        
        inactivityTimeoutRef.current = setTimeout(() => {
            if (messageClosed) {
                setMessageClosed(false);
                setMessageShown(false);
                messageTimeoutRef.current = setTimeout(() => {
                    showFloatingMessage();
                }, 5000); // Mostrar después de 5 segundos de inactividad
            }
        }, 30000); // 30 segundos de inactividad
    };

    // Manejar click en el botón de WhatsApp
    const handleWhatsAppClick = () => {
        closeFloatingMessage();
        setShowNotificationBadge(false);
        setNotificationCount(0);
    };

    // useEffect para inicializar el timer inicial
    useEffect(() => {
        // Mostrar badge después de 5 segundos
        badgeTimeoutRef.current = setTimeout(() => {
            showNotificationOnly();
        }, 15000);

        // Iniciar el timer para mostrar el mensaje después de 10 segundos
        messageTimeoutRef.current = setTimeout(() => {
            showFloatingMessage();
        }, 10000);

        // Cleanup al desmontar el componente
        return () => {
            if (messageTimeoutRef.current) {
                clearTimeout(messageTimeoutRef.current);
            }
            if (inactivityTimeoutRef.current) {
                clearTimeout(inactivityTimeoutRef.current);
            }
            if (autoHideTimeoutRef.current) {
                clearTimeout(autoHideTimeoutRef.current);
            }
            if (badgeTimeoutRef.current) {
                clearTimeout(badgeTimeoutRef.current);
            }
        };
    }, []);

    // useEffect para detectar actividad del usuario
    useEffect(() => {
        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
        
        events.forEach(event => {
            document.addEventListener(event, resetInactivityTimer, true);
        });

        // Cleanup
        return () => {
            events.forEach(event => {
                document.removeEventListener(event, resetInactivityTimer, true);
            });
        };
    }, [messageClosed]);


    useEffect(() => {
        if (showWasi){
            const blinkInterval = setInterval(() => {
                const badge = document.querySelector('.whatsapp-notification-badge');
                if (badge) {
                    badge.classList.add('blink');
                    setTimeout(() => badge.classList.remove('blink'), 3000);
                }
            }, 10000); // Parpadea cada 10 segundos
            return () => clearInterval(blinkInterval);
        }
}, []);

    return (
        <div>
             {/* Start Contact Top Area  */}
 <div className="rn-contact-top-area pt--100 pb--70 bg_color--5">
                    <div className="container">

                        <div className="row">
                            <div className="col-12 col-md-6">
                            <div className="rn-address" style={{border: "2px solid #ebebeb"}}>
                                <div className="icon" style={{top: "-29px"}}>
                                    <GoRocket style={{fontSize: "35px"}} />
                                </div>
                                <div className="inner">
                                    <h4 className="title">DojoFullStack</h4>
                                    {!langUS ?
                                    <>
                                    <p>
                                    🚀 Startup educativa de Desarrollo Full Stack
                                    </p>
                                    <p>
                                    🌏 Desde cualquier parte del mundo.
                                    </p>
                                    <p>
                                    💻 100% online en vivo.
                                    </p>
                                    </>:
                                    <>
                                    <p>
                                     🚀 Educational Startup of Full Stack Web Development.
                                     </p>
                                     <p>
                                     🌏 From anywhere in the world.
                                     </p>
                                     <p>
                                     💻 100% online live
                                     </p>
                                    </>    
                                }
                                   
                                </div>
                            </div>
                        </div>

                          

                            {/* Start Single Address  */}
                            <div className="col-12 col-md-6">
                            <div className="rn-address" style={{border: "2px solid #ebebeb"}}>
                                <div className="icon" style={{top: "-29px"}}>
                                        <MdContactPhone style={{fontSize: "35px"}} />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Email</h4>
                                        
                                         {langUS ?
                                            <p><a target="_blank" href="mailto:hello@dojofullstack.com?subject=Information Bootcamp">hello@dojofullstack.com</a></p>:
                                            <p><a target="_blank" href="mailto:hola@dojofullstack.com?subject=Informes Bootcamp">hola@dojofullstack.com</a></p>                                         
                                         }

                                         {!langUS ?
                                         <>
                                           <h4 className="title mt-2">Whatsapp</h4>
                                        <p><a target="_blank" href="https://api.whatsapp.com/send?phone=51936670597&text=Hola, me gustaría obtener más información sobre el bootcamp de desarrollador full stack.">
                                        +51 936 670 597
                                        </a></p>
                                         </> :
                                         <>
                                           <h4 className="title mt-2">Phone</h4>
                                        <p><a target="_blank" href="tel:+13658005693">
                                        +1 365-800-5693
                                        </a></p>
                                         </> 
                                         }
                                    </div>
                                </div>
                            </div>
                            {/* End Single Address  */}


                        </div>
                    </div>
                </div>
                {/* End Contact Top Area  */}

                <div className="footer-style-2 ptb--30 bg_image bg_image--1" data-black-overlay="6">
           

                <div className="col-12">
                       <div className="inner">
                        
                       <div className="inner">
                    <div className="contact-form--1">
                        <div className="container" style={{maxWidth: "550px"}}>
                            <div className="row row--35 align-items-start">
                                <div className="col-12">



                                <div style={{textAlign: "-webkit-center", marginTop: "15px"}} className="form-wrapper">
                           
                            
                        </div>
                        </div>
                        </div>
                        </div>
                        </div>
                    </div>
                        

                       </div>
                   </div>

           <div className="wrapper plr--50 plr_sm--20" style={{paddingBottom: "50px"}}>
                <div className="row text-white" style={{margin: "15px"}}>
                   <div className="col-md-3 col-12">
                        <a href="/">Bootcamp Full Stack</a>
                    </div>
               
          
                    <div className="col-md-3 col-12">
                           <a href="/#preguntas-frecuentes">
                           
                           {langUS ? "Frequently Asked Questions": "Preguntas Frecuentes"}
                           </a>
                    </div>
                
                    <div className="col-md-3 col-12">
                        {langUS ?
                              <a href="/privacy-policies">
                                Privacy policies
                              </a>:
                                <a href="/politicas-privacidad">
                                Políticas de Privacidad
                                </a>                    
                        }
                         
                    </div>
                    <div className="col-md-3 col-12">

                         {langUS ?
                              <a href="/refund-policies">
                                Refund Policies
                              </a>:
                                <a href="/politicas-reembolso">
                                Políticas de Reembolso
                                </a>                    
                        }

                    
                    </div>


               </div>
               
               <div className="row align-items-center justify-content-between">

             

                   <div className="col-lg-4 col-md-6 col-sm-6 col-12 mb-5">
                       <div className="inner">
                           <div className="logo text-center text-sm-left mb_sm--20">
                               <a href="https://dojofullstack.com">
                                   <img height="65px" src="/assets/images/logo/logo_dojo_2026.webp" alt="DojoFullStack"/>
                               </a>
                           </div>
                       </div>
                   </div>
                   <div className="col-lg-4 col-md-6 col-sm-6 col-12 mb-5">
                       <div className="inner text-center">
                           <ul className="social-share rn-lg-size d-flex justify-content-center liststyle">
                           <li key="4"><a style={{color: "#00acee"}} target="blank" href={"https://twitter.com/DojoFullStack"}> <FaTwitter style={{fontSize: "30px"}}/>  </a></li>
                           <li key="1"><a style={{color: "#3b5998"}} target="blank" href={"https://www.facebook.com/DojoFullStack"}> <FaFacebookF style={{fontSize: "30px"}}/> </a></li>
                            <li key="3"><a style={{color: "#E1306C"}} target="blank" href={"https://www.instagram.com/dojofullstack"}> <FaInstagram style={{fontSize: "30px"}}/> </a></li>
                            <li key="2"><a style={{color: "#FE2C55"}} target="blank" href={"https://www.tiktok.com/@dojofullstack"}> <FaTiktok style={{fontSize: "30px"}}/> </a></li>
                           </ul>
                       </div>
                   </div>
                   <div className="col-lg-4 col-md-12 col-sm-12 col-12 mb-5">
                       <div className="inner text-lg-right text-center mt_md--20 mt_sm--20">
                           <div className="text">
                               <p>Copyright © 2025 DojoFullStack -  {!langUS ? "Todos los derechos reservados.": "All rights reserved."} </p>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       </div>

           {/* Botón de WhatsApp con badge de notificación */}
           <div className="whatsapp-container">
               <a id="whatsapp-btn" target="_blank" href={"https://api.whatsapp.com/send?phone=51936670597&text=Hola, me gustaría obtener más información sobre el bootcamp de desarrollador full stack. ".concat(fbclid_short_code ? `%0A%0AMi ticket de atención es: %23${fbclid_short_code}`: "")}>
                   <button
                       id="whatsapp"
                       className="whatsapp"
                       style={{display: "none", border:"none"}}
                       onMouseEnter={resetMessageTimer}
                       onClick={handleWhatsAppClick}
                   >
                       <span className="whatsapp-icon">
                           <BsWhatsapp />
                       </span>
                   </button>
               </a>
               
               {/* Badge de notificación */}
               {showWasi && showNotificationBadge && (
                   <div className="whatsapp-notification-badge">
                       {notificationCount}
                   </div>
               )}
           </div>

        {/* Mensaje flotante */}
        {showWasi && <div 
            id="floating-message" 
            className={`floating-message ${showMessage ? 'show animate' : ''}`}
        >
            {langUS ? "Do you have any questions?" : "¿Tienes alguna pregunta?"}
            <button 
                className="close-btn" 
                onClick={closeFloatingMessage}
                type="button"
            >
                ×
            </button>
        </div>}

       <ToastContainer
                position="bottom-center"
                autoClose={5000}
                zIndex={100000}
                />
        </div>
        
       
    )
}
export default FooterTwo;